<template>

    <section class="main">
        <Lightbox v-show="modal" />
        <Carousel :images="imgs"/>
        <Realisations :works="imgs"/>
        <About/>
        <Contact/>
    </section>
</template>

<script>
    import Carousel from "../Carousel"
    import Realisations from "../Realisations"
    import About from "../About"
    import Contact from "../Contact"
    import Lightbox from '../Lightbox'
    import {EventBus} from '../../bus.js'

    export default {
        data() {
            return {
                modal:false,
                imgs: [
                    {
                        id: 1544,
                        title: "Nouvelle Construction",
                        location: "4020 - Fayenbois",
                        category: "in-progress",
                        url: "/img/photos/in-progress/fayenbois-2.jpg",
                        images:["/img/photos/in-progress/fayenbois-1.jpg","/img/photos/in-progress/fayenbois-2.jpg"]
                    },
                    {
                        id: 1,
                        title: "Maison architecte",
                        location: "4000 - Liège",
                        category: "habitations",
                        url: "/img/photos/nouvelles-habitations/architecte-2.jpg",
                        images:["/img/photos/nouvelles-habitations/architecte-2.jpg","/img/photos/nouvelles-habitations/architecte-1.jpg"]
                    },
                    {
                        id: 14,
                        title: "Nouvelles habitations Chaudfontaine",
                        location: "4050 - Chaudfontaine",
                        category: "habitations",
                        url: "/img/photos/nouvelles-habitations/chaudfontaine-2.jpg",
                        images:["/img/photos/nouvelles-habitations/chaudfontaine-2.jpg","/img/photos/nouvelles-habitations/chaudfontaine-1.jpg"]
                    },
                    {
                        id: 18,
                        title: "Nouvelles habitation Soumagne",
                        location: "4630 - Soumagne",
                        category: "habitations",
                        url: "/img/photos/nouvelles-habitations/soumagne-2.jpg",
                        images:["/img/photos/nouvelles-habitations/soumagne-2.jpg","/img/photos/nouvelles-habitations/soumagne-1.jpg","/img/photos/nouvelles-habitations/soumagne-3.jpg"]
                    }
                ],
                currentIndex: 1,
                imgsNumber: 0,
                interval: null
            }
        },
        methods: {
            scrollMeTo(refName) {
                let element = this.$refs[refName],
                    top = element.offsetTop;

                window.scrollTo(0, top);
            }
        },
        components: {
            About,
            Realisations,
            Carousel,
            Contact,
            Lightbox
        },
        created(){
            EventBus.$on('change_modal', data => {
                this.modal = data.modal
            });
        }
    }
</script>

<style lang="scss">
    @import "../../assets/styles/main.scss";
</style>